export default __webpack_public_path__ + "static/media/percentage_d.19cdae0f.svg";